import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { ManikEntityFE } from 'src/manik-library/ManikEntityFE';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ManikEntityService } from 'src/manik-library/ManikEntityService';
import { DOCUMENT } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-otp-handler',
  templateUrl: './otp-handler.component.html',
  styleUrls: ['./otp-handler.component.scss']
})
export class OtpHandlerComponent extends ManikEntityFE implements OnInit {
  IsInitialized = false;
  public submitted: boolean = false;
  @Input() OTPHandle: string = '';
  @Output() OTPVerified = new EventEmitter();
  OTPForm: FormGroup;
  ErrorMessage: string = '*required'
  requestSent: boolean = false;
  populateControls(): void {
    throw new Error("Method not implemented.");
  }
  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }

  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super();


    this.OTPForm = this.formBuilder.group({
      OTP: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.InitOTP();
  }

  InitOTP() {
    this.IsInitialized = false;
    this._manikEntityService.manikWebAPIConnect("http://bizbackend.manikworks.com/unitran", null, null)
      .subscribe(success => { this.IsInitialized = true });
  }

  VerifyOTP() {
    this.submitted = true;
    this.ErrorMessage = '*required'
    if (this.OTPForm.invalid) {

      return;
    }
    this.requestSent = true;

        const newheaders = new HttpHeaders({
          'EntityActionType': 'VERIFY.OTP',
          'OTPHandle': this.OTPHandle,
          'EnteredOTP': this.OTPForm.value.OTP,
          'Authorization':  sessionStorage.getItem('Token'),
          'PortalContext': 'INSTA-AU',
          'PortalDS': 'INSTA-AU'
        });
      this._manikEntityService.manikWebAPIConnect("http://entityserver.manikworks.com/instaotp", null, { headers: newheaders })
          .subscribe(data => {
            this.OTPSubmitted(data);
            this.requestSent = false;
          });
     

  }

  ResendOTP() {

        const newheaders = new HttpHeaders({
          'EntityActionType': 'RESEND.OTP',
          'OTPHandle': this.OTPHandle,
          'Authorization':  sessionStorage.getItem('Token'),
          'PortalContext': 'INSTACITI',
          'PortalDS': 'INSTA-AU'
        });
        // newheaders.append('EntityActionType', 'RESEND.OTP');
        // newheaders.append('OTPHandle', this.OTPHandle);
        // newheaders.append('Authorization', token.STATUS);
        // newheaders.append('PortalContext', 'INSTACITI');
        // newheaders.append('PortalDS', 'INSTA-AU');
        // let newoptions = new RequestOptions({ headers: newheaders });
        this._manikEntityService.manikWebAPIConnect("http://entityserver.manikworks.com/instaotp", null, { headers: newheaders })
          .subscribe(success => {
            //this.OTPSubmitted(success);
            let resp: any = success;
            this.OTPHandle = resp.STATUS;
            this.InitOTP();
          });

  }

  OTPSubmitted(data) {
    if (data.STATUS == 'SUCCESS') {
      this.OTPVerified.emit('Y');
    }
    else if (data.STATUS == 'FAILURE') {

      this.ErrorMessage = 'Invalid OTP'
    }
    else if (data.STATUS == 'EXPIRED') {

      this.ErrorMessage = 'OTP Expired. Please request a new OTP'
    }
    else if (data.STATUS == 'INVALID') {

      this.ErrorMessage = 'OTP Expired. Please request a new OTP'
    }
  }

}
